var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoggedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_5452_12781)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 38,
    height: 38,
    rx: 10,
    fill: "url(#paint0_linear_5452_12781)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0597 29.6475C31.3441 30.9295 33.0805 29.0524 31.8331 27.8753C31.1009 27.1836 29.7437 27.6809 29.7437 28.815C29.7437 29.1239 29.8558 29.4185 30.0597 29.6475ZM35.1091 29.6475C36.3935 30.9295 38.1299 29.0536 36.8825 27.8753C36.1502 27.1836 34.793 27.6809 34.793 28.815C34.793 29.1239 34.9063 29.4185 35.1091 29.6475ZM40.1597 29.6475C41.4441 30.9295 43.1805 29.0524 41.933 27.8753C41.2008 27.1836 39.8436 27.6809 39.8436 28.815C39.8436 29.1239 39.9557 29.4185 40.1597 29.6475ZM19.9598 29.6487C21.2454 30.9307 22.9806 29.0512 21.7308 27.8741C20.9997 27.186 19.6438 27.6809 19.6438 28.815C19.6438 29.1239 19.7559 29.4185 19.9598 29.6487ZM25.0092 29.6475C26.2959 30.9319 28.0311 29.05 26.7813 27.8741C26.0491 27.1848 24.6943 27.6821 24.6943 28.815C24.6931 29.1239 24.8052 29.4185 25.0092 29.6475ZM35.9081 11.7181C31.5456 7.35568 24.0588 10.4611 24.0588 16.6255C24.0588 22.7898 31.5456 25.8953 35.9081 21.5329C38.6176 18.8234 38.6176 14.4276 35.9081 11.7181ZM25.8188 23.5915C27.2654 24.6696 29.0577 25.3065 30.9994 25.3065C32.9412 25.3065 34.7345 24.6684 36.1801 23.5915H44.1441C44.2753 23.5915 44.3934 23.644 44.4769 23.7275V23.7311C44.5627 23.8169 44.6164 23.935 44.6164 24.0638V31.8501C44.6164 31.9813 44.5639 32.0994 44.4804 32.1829H44.4769C44.391 32.2687 44.2729 32.3224 44.1441 32.3224H17.8551C17.7263 32.3224 17.6082 32.2687 17.5223 32.1829H17.5188C17.4353 32.0994 17.3828 31.9825 17.3828 31.8513V24.0637C17.3828 23.8061 17.5975 23.5915 17.8551 23.5915L25.8188 23.5915ZM33.6873 13.581C34.4971 12.7713 35.7278 14.002 34.918 14.8118L30.0595 19.6703C29.7196 20.0102 29.1686 20.0102 28.8288 19.6703L27.0804 17.922C26.2707 17.1122 27.5014 15.8815 28.3112 16.6913L29.4441 17.8242L33.6873 13.581Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5452_12781",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5452_12781"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5452_12781"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_5452_12781"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5452_12781",
    result: "effect2_dropShadow_5452_12781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5452_12781",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5452_12781",
    x1: 12,
    y1: 2,
    x2: 50,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009689"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedin);
export default __webpack_public_path__ + "static/media/Logged in.abd6f4ec15a1b58ecb39097e9e0f7d0a.svg";
export { ForwardRef as ReactComponent };